var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98223 7.99964L0.366117 2.22558C-0.122039 1.79955 -0.122039 1.10883 0.366117 0.682801C0.854272 0.256775 1.64573 0.256775 2.13388 0.682801L9.63388 7.22826C10.122 7.65428 10.122 8.34501 9.63388 8.77103L2.13388 15.3165C1.64573 15.7425 0.854272 15.7425 0.366117 15.3165C-0.122039 14.8905 -0.122039 14.1997 0.366117 13.7737L6.98223 7.99964Z",
    fill: "#4FC0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.04b49b3410ed02535e55cf320fbcb387.svg";
export { ForwardRef as ReactComponent };